import { createAction } from '@reduxjs/toolkit'
import { SpotMatchRecord, SpotOrderRecord } from 'api/v1/spot'
import {
  CreateOrderOption,
  LastInputAmountType,
  OrderDirection,
  OrderModeNames,
  SpotOrderTabType,
} from './types'
import { WsOrderMessage } from '../../ws/zkex/messages/orders'

export const updateCurrentSpotSymbol = createAction<number>(
  'spot/updateCurrentSpotSymbol'
)
export const updateSpotOrderRecordAction = createAction<
  WsOrderMessage<SpotOrderRecord>
>('spot/updateSpotOrderRecordAction')
export const cleanUserSpotDataAction = createAction(
  'spot/cleanUserSpotDataAction'
)
export const updateSpotBadgeOrderAction = createAction<boolean>(
  'spot/updateSpotBadgeOrderAction'
)
export const updateSpotBadgeTradeAction = createAction<boolean>(
  'spot/updateSpotBadgeTradeAction'
)
export const updateCreateOrderOption = createAction<{
  option: keyof CreateOrderOption
  value: string
}>('spot/updateCreateOrderOption')
export const updateSpotSelectedOrderMode = createAction<OrderModeNames>(
  'spot/updateSpotSelectedOrderMode'
)
export const updateLastInputAmountType = createAction<LastInputAmountType>(
  'spot/updateLastInputAmountType'
)
export const updateOrderDirection = createAction<OrderDirection>(
  'spot/updateOrderDirection'
)
export const updateCancelSpotPendingIds = createAction<number[]>(
  'spot/updateCancelSpotPendingIds'
)
export const updateCancelAllSpotAction = createAction<boolean>(
  'spot/updateCancelAllSpotState'
)
export const updateSpotCurrentOrderTab = createAction<SpotOrderTabType>(
  'spot/updateSpotCurrentOrderTab'
)
export const updateSpotMatchRecordAction = createAction<
  WsOrderMessage<SpotMatchRecord>
>('spot/updateSpotMatchRecordAction')
export const updateSpotPostOnlyAction = createAction<boolean>(
  'spot/updateSpotPostOnlyAction'
)
